// extracted by mini-css-extract-plugin
export var about = "style-module--about--1+6p0";
export var heading = "style-module--heading--U3384";
export var headings = "style-module--headings--8aTls";
export var image = "style-module--image--DxO6C";
export var title = "style-module--title--e7HtM";